import { useCallback, useContext, useEffect } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { SocketContext } from '@/contexts/rtm';
import type { ConversationEvent } from '@/shared/types/chat';
import { AccountId, SocketEvent, UserEvent } from '@/shared/types/rtm';

import { endpoints as eventsEndpoints } from './useConversationEvents';

const useRtmConversationEvents = (deskId: string, sessionId: string) => {
  const { socket } = useContext(SocketContext);
  const queryClient = useQueryClient();

  const handleCreated = useCallback<UserEvent<ConversationEvent & AccountId>>(
    ({ data }) => {
      if (data.session_id !== sessionId) {
        return;
      }
      queryClient.invalidateQueries({ queryKey: [eventsEndpoints.events(deskId, sessionId)] });
    },
    [deskId, queryClient, sessionId]
  );

  useEffect(() => {
    socket?.on(SocketEvent.conversations_events_created, handleCreated);
    return () => {
      socket?.off(SocketEvent.conversations_events_created, handleCreated);
    };
  }, [handleCreated, socket]);
};

export default useRtmConversationEvents;
